import React, { useEffect } from "react";
import Common_Title_1 from "../../../../common/common_components/common_title_1/Common_Title_1";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import { AllDonationCancellation } from '../../../../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";

const Donation_Cancellation = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const donation_cancellation = useSelector((state) => state.footer.donation_cancellation);

  // console.log("all_donation_cancellation",donation_cancellation)

  useEffect(() => {
    dispatch(AllDonationCancellation());
  }, [dispatch]);

  return (
    <section className="Donation_Cancellation Privacy_Policy">
      <Common_Title_1 subText="Donation Cancellation & Refund Policy" />

      <p className="">{parse(donation_cancellation?.content || "")}</p>

      <div className="btn_holder">
        <Pink_Btn btnText={"OK"} onClick={() => { navigate("/settings/menu") }} />
      </div>
    </section>
  );
};

export default Donation_Cancellation;
